import { Holding, holdingSchema } from "@boark/shared/types/holding";
import { HoldingCreate } from "@boark/shared/types/holding-create";
import { HoldingUpdate } from "@boark/shared/types/holding-update";
import {
  HoldingWithApartmentAndSublets,
  holdingWithApartmentAndSubletsSchema,
} from "@boark/shared/types/holding-with-apartment-and-sublets";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getHoldings(): Promise<HoldingWithApartmentAndSublets[]> {
  return getRequest(
    `${API_BASE_URL}/holding`,
    z.array(holdingWithApartmentAndSubletsSchema),
  );
}

export async function getHolding(
  id: string,
): Promise<HoldingWithApartmentAndSublets> {
  return await getRequest(
    `${API_BASE_URL}/holding/${id}`,
    holdingWithApartmentAndSubletsSchema,
  );
}

export async function createHolding(holding: HoldingCreate): Promise<Holding> {
  return await postRequest(`${API_BASE_URL}/holding`, holding, holdingSchema);
}

export async function updateHolding(
  id: string,
  holding: HoldingUpdate,
): Promise<Holding> {
  return await putRequest(
    `${API_BASE_URL}/holding/${id}`,
    holding,
    holdingSchema,
  );
}

export async function deleteHolding(id: string): Promise<void> {
  return await deleteRequest(`${API_BASE_URL}/holding/${id}`);
}
